import { colors, FONT_FAMILIES } from 'common/styles/style-constants';
import styled from 'styled-components';

export const Card = styled.section`
  width: 140px;
  font-family: ${FONT_FAMILIES.circular};
  margin-right: 6px;
`;

export const LinkWrapper = styled.div``;

export const HeadingWrapper = styled.div`
  padding: 5px 13px;
  border-radius: 5px 5px 0 0;
  display: flex;
  align-items: center;
  border: 1px solid;

  background-color: ${props => props.backgroundColor};
  border-color: ${props => props.borderColor};
  color: ${props => props.color};
`;

export const Heading = styled.h1`
  display: inline;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  margin: 0;
  color: inherit;
  margin-left: 6px;
`;

export const BodyWrapper = styled.div`
  padding: 6px 8px 8px 13px;
  border-radius: 0 0 5px 5px;
  border: 1px solid ${colors.gray4};
  border-top: none;
`;

export const Rating = styled.p`
  font-size: 18px;
  color: ${colors.gray9};
  margin: 0;
  line-height: 23px;
`;

export const ReviewsCount = styled.p`
  font-size: 13px;
  font-weight: 400;
  margin: 0;
  line-height: 18px;
  font-family: ${FONT_FAMILIES.openSans};
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  color: ${colors.gray8};
`;
